import React, { useState } from 'react'
import { Checkbox } from 'semantic-ui-react'

import { toast } from 'libs/toast'
import useAxios, { mutate } from 'hooks/useAxios'
import useSaveUserActivityLog, { ACTION_NAME } from 'hooks/useSaveUserActivityLog'

export default function SurveyCreateEventSetting({ surveyIntegrationSetting, disabled }) {
  const defaultIsActive = surveyIntegrationSetting.additional_option.is_active
  const [isActive, setIsActive] = useState(defaultIsActive)
  const { fetch: updateCreateEventSettingAPI } = useAxios({
    url: `survey/survey-integration-setting/by-survey/${surveyIntegrationSetting.survey.token}/additional-option/`,
    method: 'patch',
    skip: true,
  })
  const saveUserActivityLog = useSaveUserActivityLog()

  /**
   *
   * @param {object} requestBody
   * @param {number} statusCode
   * @param {number} surveyId
   */
  function _saveUserActivityLog(requestBody, statusCode, surveyId) {
    const action = ACTION_NAME.connected_intercom

    const target = `sur_${surveyId}`
    saveUserActivityLog({
      action,
      target,
      statusCode,
      requestBody,
    })
  }

  function updateCreateEventSetting(_, { checked }) {
    setIsActive(checked)
    const data = {
      name: 'push_contact_event',
      integration_type: 'intercom',
      option_name: 'is_active',
      option_value: checked,
    }

    const logRequestBody = {
      integration: 'push_contact_event',
      enabled: checked,
    }
    updateCreateEventSettingAPI({
      data,
    })
      .then((response) => {
        toast.success('Settings updated.')

        mutate(
          'survey/survey-integration-setting/by-integration/?integration_type=intercom&name=push_contact_event'
        )
        _saveUserActivityLog(logRequestBody, response.status, surveyIntegrationSetting.survey.id)
      })
      .catch((error) => {
        toast.error(
          'Oops! Something went wrong. Please try again or contact Simplesat support for help.'
        )
        setIsActive(!checked)
        _saveUserActivityLog(
          logRequestBody,
          error.response.status,
          surveyIntegrationSetting.survey.id
        )
      })
  }
  return (
    <div className="my-2">
      <Checkbox
        checked={isActive}
        disabled={disabled}
        toggle
        label={surveyIntegrationSetting.survey.name}
        onChange={updateCreateEventSetting}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomCreateEventIntegration/SurveyCreateEventSetting.js